import _ from 'lodash';
import { computed, ref, getCurrentInstance } from '@vue/composition-api';
const sharedData = ref({
  session: {},
});

export function useActionDesk() {
  const vm = getCurrentInstance()!;
  const cards = computed(() => vm.proxy.$store.state.cards);

  function getPresentation(card: object) {
    return {
      template: _.get(card, 'data.presentation.template')! as string,
      code: _.get(card, 'data.presentation.code')! as string,
      style: _.get(card, 'data.presentation.style')! as string + '\n' + _.get(card, 'data.data.style', '')! as string,
    };
  }

  async function downloadCard(cardId: string) {
    const GET_CARD_BY_ID = 'refetchCard';
    return vm.proxy.$store.dispatch(GET_CARD_BY_ID, { cardId });
  }

  async function registerComponent(params: object) {
    return vm.proxy.$helpers.registerWithCommonContext(params);
  }

  async function unregisterComponent(params: object) {
    return vm.proxy.$helpers.unregisterComponent(params);
  }

  return {
    cards,
    sharedData,
    downloadCard,
    getPresentation,
    registerComponent,
    unregisterComponent,
  };
}
